import React from 'react';

interface DeliveryIconProps {
  className?: string;
  style?: React.CSSProperties;
}

export const DeliveryIcon: React.FC<DeliveryIconProps> = ({ className, style }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        d="M10 16.5L13 17.5C13 17.5 20.5 16 21.5 16C22.5 16 22.5 17 21.5 18C20.5 19 17 22 14 22C11 22 9 20.5 7 20.5C5 20.5 2 20.5 2 20.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 14.5C3 13.5 5 12 7 12C9 12 13.75 14 14.5 15C15.25 16 13 17.5 13 17.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 9V5C8 4.44771 8.4477 4 9 4H21C21.5523 4 22 4.44771 22 5V13"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5 4H12.5V8.5H17.5V4Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DeliveryIcon;
